module.exports = __webpack_public_path__ + "static/media/PC_top_ranking_product.41b9eb4b.jpg";